<app-card [title]="'database.persons.createPage.basicInfo'" titleSize="large">
    <ng-template #content>
        @if (form()) {
            <div class="grid-2col_auto gridGap-1">
                <!-- left column -->
                <div class="flex-column gap align-items-center">
                    <!-- photo upload -->
                    <div class="flex justify-content-center">
                        <app-input-file-btn
                            [owner]="'person_' + (person()?.id || 'null')" [replaceByOwner]="true"
                            (uploaded)="onFileUpload($event)"
                            [disabled]="!canEdit()"
                        >
                            <app-avatar
                                size="xxxxlarge"
                                [initials]="person() | personInitials"
                                [userSex]="person()?.sex"
                                [src]="person()?.image || newFile()">
                            </app-avatar>
                        </app-input-file-btn>
                    </div>

                    @if (this.person()?.image) {
                        <app-delete-button
                            label="person.basicInfo.message.deleteImage"
                            (clickEvent)="deleteImage()"
                        ></app-delete-button>
                    }

                    <!-- sex select -->
                    <app-select-button-sex-input [form]="form()" [disabled]="!canEdit()"></app-select-button-sex-input>
                </div>

                <!-- right column -->
                <div class="grid-2col input-grid-gaps p-1">
                    @if (!person()?.id) {
                        <app-select-input
                            id="serviceId"
                            class="fr-2"
                            [form]="form()"
                            [staticOptions]="store.services()"
                            [valueKey]="'id'">
                        </app-select-input>
                    }

                    <app-text-input id="titleBeforeName" [form]="form()" [disabled]="!canEdit()"></app-text-input>
                    <div></div>

                    <app-text-input id="name" [form]="form()" [disabled]="!canEdit()"></app-text-input>
                    <app-text-input id="surname" [form]="form()" [disabled]="!canEdit()"></app-text-input>

                    <app-text-input id="titleAfterName" [form]="form()" [disabled]="!canEdit()"></app-text-input>
                    <app-text-input id="birthSurname" [form]="form()" [disabled]="!canEdit()"></app-text-input>

                    <div class="fr-2">{{ 'database.persons.createPage.documentNames' | translate }}</div>

                    <app-text-input id="documentName" label="inputs.name" [form]="form()"
                        [disabled]="!canEdit()"></app-text-input>
                    <app-text-input id="documentSurname" label="inputs.surname" [form]="form()"
                        [disabled]="!canEdit()"></app-text-input>

                    <app-text-input id="alias" class="fr-2" [form]="form()" [disabled]="!canEdit()"></app-text-input>

                    @if (showInsuranceNumber()) {
                        <app-text-input id="insuranceNumber" class="fr-2" [form]="form()"
                            [disabled]="!canEdit()"></app-text-input>
                    }

                    @if (this.useDiet()) {
                        <app-text-area-input
                            id="dietSpec" label="person.basicInfo.dietSpec"
                            class="fr-2"
                            [form]="form()" [disabled]="!canEdit()"
                        ></app-text-area-input>
                    }
                </div>
            </div>
        }
    </ng-template>
</app-card>
